import { render } from "./Section_Expenses.vue?vue&type=template&id=252ea523"
import script from "./Section_Expenses.vue?vue&type=script&lang=js"
export * from "./Section_Expenses.vue?vue&type=script&lang=js"

import "./Section_Expenses.vue?vue&type=style&index=0&id=252ea523&lang=scss"
script.render = render

export default script